import styled from 'styled-components';

import { IPrimaryButton } from './types';

export const CustomButton = styled.button<Pick<IPrimaryButton, 'isDark'>>`
  background-color: ${({ isDark, theme }) =>
    isDark ? theme.colors.primary.light : theme.colors.primary.main};
  color: white;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.lighter};
  }

  &:disabled {
    background-color: ${({ isDark }) => (isDark ? '#B7BAD5' : '#E3E4E5')};
    color: ${({ isDark }) => (isDark ? '#33344F' : '#BBBCBF')};
    cursor: not-allowed;
  }
`;
